const isScrollableOverflow = (value: string) =>
  value === "auto" || value === "scroll" || value === "overlay";

const canScrollVertically = (element: Element) =>
  element.scrollHeight > element.clientHeight;

const hasScrollableOverflow = (element: Element) => {
  const styles = window.getComputedStyle(element);
  return (
    isScrollableOverflow(styles.overflowY) ||
    isScrollableOverflow(styles.overflow)
  );
};

const findEffectiveScrollRoot = (element: Element | null) => {
  if (!element || typeof window === "undefined") return null;

  let current = element.parentElement;
  while (
    current &&
    current !== document.body &&
    current !== document.documentElement
  ) {
    if (hasScrollableOverflow(current) && canScrollVertically(current)) {
      return current;
    }
    current = current.parentElement;
  }

  return null;
};

export { findEffectiveScrollRoot };
